import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Spinner } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { PDFDownloadLink } from '@react-pdf/renderer';
import DashboardPDF from '../PdfFiles/DashboardPDF';
import { useAuth } from '../../hooks/useAuth';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import html2canvas from 'html2canvas';
const BreadCrumbs = () => {
    const location = useLocation();
    const { user, getToken } = useAuth();
    const [pdfData, setPdfData] = useState({}); //state to store the API data
    const [allUnits, setAllUnits] = useState(null);
    const [chartImage, setChartsImage] = useState(false);
    var locArray = location.pathname.split('/');

    const [showDownloadLink, setShowDownloadLink] = useState(false);

    useEffect(() => {
        let timer;
        if (pdfData) {
            timer = setTimeout(() => {
                setShowDownloadLink(true);
            }, 2000); // 10 seconds
        }
        // Clean up the timer if the component unmounts before the time is up
        return () => clearTimeout(timer);
    }, [Object.keys(pdfData)?.length]);
    // var locArray = location.pathname.split('/').toString().split('-').toString().split(',');

    const getPath = () => {
        if (location.pathname === '/') {
            locArray = ['Dashboard'];
            return 'Dashboard';
        } else if (locArray?.length > 2) {
            return locArray[2].replace('-', ' ');
        } else {
            return locArray[1];
        }
    };

    //API call to get the dashboard data
    const getDashboardData = () => {
        const authToken = getToken();
        if (authToken) {
            new WebApiCalls()
                .getCommonSettings(authToken)
                .then((res) => {
                    if (res?.code && res?.code == 200 && res?.result == 'success') {
                        //when data is received, set it to the state
                        setPdfData(res.data);
                        getMeasuringUnits();
                    }
                })
                .catch((err) => {});
        }
    };
    const getMeasuringUnits = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getRewardSettings(token)
                .then((res) => {
                    if (res?.code == 200) {
                        setAllUnits(res?.data);
                    }
                })
                .catch((err) => {});
        }
    };

    //useEffect to run the API call when the component is rendered
    useEffect(() => {
        if (user && user.role !== 'vendor' && user.role !== 'admin') {
            getDashboardData();
        }
    }, [user]);
    function saveScreenshot(canvas) {
        canvas.toBlob(function (blob) {
            setChartsImage(URL.createObjectURL(blob));
        });
    }

    useEffect(() => {
        if (pdfData && location.pathname === '/' && showDownloadLink) {
            const elementToCapture = document.getElementById('chartId');

            if (elementToCapture) {
                html2canvas(elementToCapture, {
                    allowTaint: true,
                    useCORS: true
                }).then(saveScreenshot);
            }
        }
    }, [pdfData, document.getElementById('chartId'), showDownloadLink]);

    return (
        <Row>
            <Col className="d-flex justify-content-between align-items-center">
                <h6 className="text-capitalize mt-2">
                    <span className=" breadcrumb-heading ms-3">{_.startCase(_.toLower(getPath()))}</span>
                </h6>

                {location.pathname === '/' && pdfData && chartImage && (
                    <PDFDownloadLink
                        document={<DashboardPDF key={chartImage} dashboardData={pdfData} units={allUnits} chartImage={chartImage} />}
                        fileName="dashboard_data.pdf"
                    >
                        {({ loading }) => (
                            <Button className="export-file justify-content-center w-140 align-items-center" style={{ background: '#198754' }}>
                                Export Stats
                            </Button>
                        )}
                    </PDFDownloadLink>
                )}
            </Col>
        </Row>
    );
};
export default BreadCrumbs;
